(function () {
    'use strict';

    angular.module('app.categories')
        .run(appRun);

    appRun.$inject = ['routerHelper'];

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'categories',
                config: {
                    url: '/categories',
                    title: 'Kategoriler',
                    abstract: true,
                    templateUrl: 'app/categories/categories.html'
                }
            },
            {
                state: 'categories.list',
                config: {
                    templateUrl: 'app/categories/categories.list.html',
                    controller: 'CategoriesListController',
                    controllerAs: 'vm',
                    url: '/list',
                    title: 'Kategori Listesi',
                    settings: {
                        nav: 3,
                        name: 'categories.list',
                        topName: 'products',
                        content: 'Kategori Listesi',
                        resource: 'menu.categories.list'
                    }
                }
            },
            {
                state: 'categories.add',
                config: {
                    templateUrl: 'app/categories/categories.add.html',
                    controller: 'CategoriesAddController',
                    controllerAs: 'vm',
                    url: '/add',
                    title: 'Kategori Ekle',
                    settings: {
                        topName: 'categories.list',
                        name: 'categories.add',
                        content: 'Kategori Ekle',
                        resource: 'menu.categories.add'
                    }
                }
            },
            {
                state: 'categories.edit',
                config: {
                    templateUrl: 'app/categories/categories.edit.html',
                    controller: 'CategoriesEditController',
                    controllerAs: 'vm',
                    url: '/edit/:CategoryId',
                    title: 'Kategori Düzenle',
                    settings: {
                        topName: 'categories.list',
                        name: 'categories.edit',
                        content: 'Kategori Düzenle',
                        resource: 'menu.categories.edit'
                    }
                }
            },
            {
                state: 'categories.detail',
                config: {
                    templateUrl: 'app/categories/categories.detail.html',
                    controller: 'CategoriesDetailController',
                    controllerAs: 'vm',
                    url: '/detail/:CategoryId',
                    title: 'Kategori Detay',
                    settings: {
                        topName: 'categories.list',
                        name: 'categories.detail',
                        content: 'Kategori Detay',
                        resource: 'menu.categories.detail'
                    }
                }
            }
        ];
    }
})();